import Vue from 'vue';
import Router from 'vue-router';

import store from '@/store';
import Index from '@/views/Index.vue';
import Job from '@/views/Job.vue';
import Contact from '@/views/Contact.vue';
import JobApply from '@/views/JobApply.vue';
import Submitted from '@/views/Submitted.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      beforeEnter: (to, from, next) => {
        store.commit('changeSectionName', 'home');
        next();
      },
    },
    {
      path: '/job/:id',
      name: 'job',
      component: Job,
      beforeEnter: (to, from, next) => {
        store.commit('changeSectionName', 'job');
        next();
      },
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
      beforeEnter: (to, from, next) => {
        store.commit('changeSectionName', 'contact');
        next();
      },
    },
    {
      path: '/job-apply/:id',
      name: 'job-apply',
      component: JobApply,
      beforeEnter: (to, from, next) => {
        store.commit('changeSectionName', 'job-apply');
        next();
      },
    },
    {
      path: '/submitted',
      name: 'submitted',
      component: Submitted,
      beforeEnter: (to, from, next) => {
        store.commit('changeSectionName', 'submitted');
        next();
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  store.commit('updateRoute', { to, from });
  next();
});

export default router;
